import { render, staticRenderFns } from "./tab-preview.vue?vue&type=template&id=3360b508&scoped=true&"
import script from "./tab-preview.vue?vue&type=script&lang=js&"
export * from "./tab-preview.vue?vue&type=script&lang=js&"
import style0 from "./tab-preview.vue?vue&type=style&index=0&id=3360b508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3360b508",
  null
  
)

export default component.exports